import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const companiesStartRequest = () => {
  return {
    type: 'COMPANIES_START_REQUEST'
  };
};

export const companiesEndRequest = () => {
  return {
    type: 'COMPANIES_END_REQUEST'
  };
};

export const getAllCompaniesSuccess = ({ data }) => {
  return {
    type: 'COMPANIES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllCompaniesError = error => {
  return {
    type: 'COMPANIES_GET_ALL_ERROR',
    payload: error
  };
};

export const addCompaniesSuccess = ({ data }) => {
  return {
    type: 'COMPANIES_ADD_SUCCESS',
    payload: data
  };
};

export const addCompaniesError = error => {
  return {
    type: 'COMPANIES_ADD_ERROR',
    payload: error
  };
};

export const editCompaniesSuccess = ({ data }) => {
  return {
    type: 'COMPANIES_EDIT_SUCCESS',
    payload: data
  };
};

export const editCompaniesError = error => {
  return {
    type: 'COMPANIES_EDIT_ERROR',
    payload: error
  };
};

export const removeCompaniesSuccess = id => {
  return {
    type: 'COMPANIES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeCompaniesError = error => {
  return {
    type: 'COMPANIES_REMOVE_ERROR',
    payload: error
  };
};

export const companiesModifyStore = ({ data }) => {
  return {
    type: 'COMPANIES_MODIFY_STORE',
    payload: data
  };
};

export const addCompanies = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(companiesStartRequest());
      const response = await api().post('/api/companies', data);
      dispatch(addCompaniesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'companies',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addCompaniesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(companiesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllCompanies = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(companiesStartRequest());
      const response = await api().get('/api/companies', { params });
      dispatch(getAllCompaniesSuccess(response));
    } catch (err) {
      dispatch(getAllCompaniesError(err));
    } finally {
      dispatch(companiesEndRequest());
    }
  };
};

export const editCompanies = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(companiesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(companiesStartRequest());
      const id = data._id;
      const response = await api().put('/api/companies/' + id, data);
      dispatch(editCompaniesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'companies',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/companies'));
      }
    } catch (err) {
      dispatch(editCompaniesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeCompanies = id => {
  return async dispatch => {
    try {
      dispatch(companiesStartRequest());
      await api().delete('/api/companies/' + id);
      dispatch(removeCompaniesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'companies',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Empresa removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeCompaniesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover empresa.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(companiesEndRequest());
    }
  };
};

export const restoreCompanies = data => {
  return async dispatch => {
    try {
      dispatch(companiesStartRequest());
      const id = data._id;
      const response = await api().put('/api/companies/' + id, data);
      dispatch(editCompaniesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'companies',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Empresa restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editCompaniesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar empresa.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(companiesEndRequest());
    }
  };
};
